import { render, staticRenderFns } from "./LiabilityLoanMortgage.vue?vue&type=template&id=381accfa"
import script from "./LiabilityLoanMortgage.vue?vue&type=script&lang=js"
export * from "./LiabilityLoanMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports